import React from "react";
import GoogleButton from "react-google-button";
import { auth } from "../../firebase/base";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import "./LoginSignup.css";

export default function SignIn() {
  const googleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Google sign-in failed:", error);
    }
  };

  return (
    <div className="login-signup-main-body">
      <div className="main">
        <div className="signup">
          <label aria-hidden="true">Sign up</label>

          <div className="google-botton-box">
            <GoogleButton onClick={googleSignIn} />
          </div>
        </div>
      </div>
    </div>
  );
}
